import React from 'react';
import { brandAssets } from '../../data/brandAssets';
type Variant = 'blue' | 'white' | 'tan';
type Kind = 'wordmark' | 'compact';
type WordmarkProps = {
  variant?: Variant;
  kind?: Kind;
  className?: string;
};
const wordmarkKey = {
  blue: 'wordmarkBlue',
  white: 'wordmarkWhite',
  tan: 'wordmarkTan'
} as const;
const compactKey = {
  blue: 'logoCompactBlue',
  white: 'logoCompactWhite',
  tan: 'logoCompactWhite'
} as const;
const textColor: Record<Variant, string> = {
  blue: 'text-brand-navy',
  white: 'text-white',
  tan: 'text-brand-tan'
};

/**
 * Renders the official BCM logo/wordmark from the supplied brand files.
 * Never redraws the mark: if an asset URL has not been supplied yet, a plain
 * typographic placeholder is shown instead.
 */
export function Wordmark({
  variant = 'blue',
  kind = 'wordmark',
  className = ''
}: WordmarkProps) {
  const src = kind === 'wordmark' ? brandAssets[wordmarkKey[variant]] : brandAssets[compactKey[variant]];
  if (src) {
    return <img src={src} alt="UCF Baptist Collegiate Ministries" className={`block w-auto ${className}`} data-id="element-51" data-mp="hsmt4vz1vefc" />;
  }
  if (kind === 'compact') {
    return <span className={`inline-flex h-10 w-10 items-center justify-center rounded-full border-2 font-display text-sm font-bold tracking-tight ${variant === 'blue' ? 'border-brand-navy text-brand-navy' : 'border-white text-white'} ${className}`} data-id="element-52" data-mp="rr2cudvqzlet">
        BCM
      </span>;
  }
  return <span className={`inline-flex flex-col leading-none ${textColor[variant]} ${className}`} data-id="element-53" data-mp="3qaj201i0av4a">
      <span className="font-display text-xl font-extrabold tracking-tight sm:text-2xl" data-id="element-54" data-mp="8u14qk6wd56n">
        UCF BCM
      </span>
      <span className="font-meta text-[9px] font-medium uppercase tracking-[0.2em] opacity-80 sm:text-[10px]" data-id="element-55" data-mp="40gcl8rzj5fd">
        Baptist Collegiate Ministries
      </span>
    </span>;
}